import useStore from '../useStore';

const useModalStore = () => {
  const { modalStore } = useStore();

  return modalStore;
};

export default useModalStore;
